import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import {
  Article as EditorialIcon,
  LocationCity as CityIcon,
} from '@mui/icons-material';

/**
 * ContentNav — top-level tabs for switching between content sections.
 * Sits at the top of EditorialList and CityList pages.
 */
export default function ContentNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const value = pathname.startsWith('/content/cms/cities') ? 1 : 0;

  return (
    <Box sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={value}
        onChange={(_, newValue) => {
          if (newValue === 0) navigate('/content/cms/editorials');
          else if (newValue === 1) navigate('/content/cms/cities');
        }}
      >
        <Tab icon={<EditorialIcon />} iconPosition="start" label="Editorials" />
        <Tab icon={<CityIcon />} iconPosition="start" label="City Guides" />
      </Tabs>
    </Box>
  );
}
